export function cpfMask(value = '', defaultEmptyReturn = ''): string {
  if (value === null || value === undefined) return defaultEmptyReturn

  const str = String(value)

  return str
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')
}
